import React from 'react';


const APIMethodTable = () => {
  const httpMethods = [
    {
      method: 'GET',
      description: 'Retrieve data from the server',
      usage: 'Fetch products, orders, or other resources',
      color: 'text-blue-600 bg-blue-50',
      examples: ['GET /products', 'GET /orders/123']
    },
    {
      method: 'POST',
      description: 'Create new resources on the server',
      usage: 'Create products, place orders, or add new data',
      color: 'text-green-600 bg-green-50',
      examples: ['POST /products', 'POST /orders']
    },
    {
      method: 'PUT',
      description: 'Update existing resources completely',
      usage: 'Replace entire product or order information',
      color: 'text-orange-600 bg-orange-50',
      examples: ['PUT /products/123', 'PUT /orders/456']
    },
    {
      method: 'PATCH',
      description: 'Partially update existing resources',
      usage: 'Update specific fields of products or orders',
      color: 'text-purple-600 bg-purple-50',
      examples: ['PATCH /products/123', 'PATCH /orders/456']
    },
    {
      method: 'DELETE',
      description: 'Remove resources from the server',
      usage: 'Delete products, cancel orders, or remove data',
      color: 'text-red-600 bg-red-50',
      examples: ['DELETE /products/123', 'DELETE /orders/456']
    }
  ];

  

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse border border-border rounded-lg">
        <thead>
          <tr className="bg-muted/50">
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              HTTP Method
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Description
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Common Usage
            </th>
            <th className="border border-border px-4 py-3 text-left text-sm font-semibold text-foreground">
              Examples
            </th>
          </tr>
        </thead>
        <tbody>
          {httpMethods?.map((method, index) => (
            <tr key={method?.method} className={index % 2 === 0 ? 'bg-background' : 'bg-muted/20'}>
              <td className="border border-border px-4 py-3">
                <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${method?.color}`}>
                  {method?.method}
                </span>
              </td>
              <td className="border border-border px-4 py-3 text-sm text-foreground">
                {method?.description}
              </td>
              <td className="border border-border px-4 py-3 text-sm text-muted-foreground">
                {method?.usage}
              </td>
              <td className="border border-border px-4 py-3">
                <div className="space-y-1">
                  {method?.examples?.map((example, idx) => (
                    <code key={idx} className="block text-xs bg-slate-100 px-2 py-1 rounded text-slate-800">
                      {example}
                    </code>
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default APIMethodTable;